import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface BrokerMembership {
  network_id: string;
  network_name: string | null;
  shipper_network_id: string | null;
  shipper_user_id: string;
  shipper_company_id: string | null;
  shipper_name: string;
  shipper_documents_verified_at: string | null;
  active_dispatch_count: number;
  joined_at: string | null;
}


/**
 * Lists the private shipper networks the signed-in broker is an accepted
 * member of. Backed by the `get_my_broker_memberships` SECURITY DEFINER RPC —
 * required because RLS on `shipper_private_networks` / `companies` doesn't let
 * brokers read the shipper's row directly.
 */
export function useBrokerMemberships(userId: string | null) {
  return useQuery({
    queryKey: ["broker-memberships", userId],
    enabled: !!userId,
    staleTime: 30_000,
    queryFn: async () => {
      const { data, error } = await supabase.rpc(
        "get_my_broker_memberships" as any,
      );
      if (error) throw error;
      return (data ?? []) as BrokerMembership[];
    },
  });
}
